var rgbaKeys = ['r', 'g', 'b', 'a'];
export function StringToRgba(string) {
  return string.replace(/(rgba?\(|\))/, '').split(',').reduce(function (color, values, index) {
    color[rgbaKeys[index]] = parseFloat(values);
    return color;
  }, {});
}
export function RgbaToString(color) {
  return "rgba(".concat(color.r, ",").concat(color.g, ",").concat(color.b, ",").concat(color.a, ")");
}
export function fade(string, opacity, escape) {
  var rgba = StringToRgba(string);
  rgba.a = opacity;
  var color = RgbaToString(rgba);
  return escape ? encodeURIComponent(color) : color;
}
export function fadeToUrl(string, opacity) {
  var _StringToRgba = StringToRgba(string),
      r = _StringToRgba.r,
      g = _StringToRgba.g,
      b = _StringToRgba.b;

  return RgbaToUrl({
    r: r,
    g: g,
    b: b,
    a: opacity
  });
}
export function RgbaToUrl(rgba) {
  var r = rgba.r,
      g = rgba.g,
      b = rgba.b,
      a = rgba.a;
  return [r, g, b, a * 255].map(function (c) {
    return c.toString(16).substring(0, 2).padStart(2, '0');
  }).join('');
}
export function HexToRGBA(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (!color) {
    return 'none';
  }

  if (color.length === 4) {
    color = color.replace(/(\w)/g, '$1$1');
  }

  var r = parseInt(color.substring(1, 3), 16);
  var g = parseInt(color.substring(3, 5), 16);
  var b = parseInt(color.substring(5, 7), 16);
  var a = alpha / 100;
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
} // https://css-tricks.com/converting-color-spaces-in-javascript/

export function RgbaToHsla(color) {
  var r = color.r,
      g = color.g,
      b = color.b,
      a = color.a; // Make r, g, and b fractions of 1

  r /= 255;
  g /= 255;
  b /= 255; // Find greatest and smallest channel values

  var cmin = Math.min(r, g, b);
  var cmax = Math.max(r, g, b);
  var delta = cmax - cmin;
  var h = 0;
  var s = 0;
  var l = 0; // Calculate hue
  // No difference

  if (delta == 0) h = 0; // Red is max
  else if (cmax == r) h = (g - b) / delta % 6; // Green is max
  else if (cmax == g) h = (b - r) / delta + 2; // Blue is max
  else h = (r - g) / delta + 4;
  h = Math.round(h * 60); // Make negative hues positive behind 360°

  if (h < 0) h += 360; // Calculate lightness

  l = (cmax + cmin) / 2; // Calculate saturation

  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1)); // Multiply l and s by 100

  s *= 100;
  l *= 100;
  return {
    h: h,
    s: s,
    l: l,
    a: a
  };
}
export function HslaToRgba(color) {
  var h = color.h,
      s = color.s,
      l = color.l,
      a = color.a;
  s /= 100;
  l /= 100;
  var c = (1 - Math.abs(2 * l - 1)) * s;
  var x = c * (1 - Math.abs(h / 60 % 2 - 1));
  var m = l - c / 2;
  var r = 0;
  var g = 0;
  var b = 0;

  if (0 <= h && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (60 <= h && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (120 <= h && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (180 <= h && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (240 <= h && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else if (300 <= h && h < 360) {
    r = c;
    g = 0;
    b = x;
  }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}
export function lighten(rgba, factor) {
  var hsla = RgbaToHsla(rgba);
  hsla.l = hsla.l + (100 - hsla.l) * factor;
  return HslaToRgba(hsla);
}
export function darken(rgba, factor) {
  var hsla = RgbaToHsla(rgba);
  hsla.l = hsla.l * (1 - factor);
  return HslaToRgba(hsla);
}